import {useEffect} from "react";

// eslint-disable-next-line
export const useMountEffect = effect => useEffect(effect, []);
// eslint-disable-next-line
export const useUnmountEffect = effect => useEffect(()=>effect, []);
// eslint-disable-next-line
export const useChillEffect = (effect = () => {}, dependencies = []) => useEffect(effect, dependencies);